module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: "documentTypeReveal"
  }, [_c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('h2', [_vm._v("Create new document type")]), _c('DocumentTypeForm', {
    model: {
      value: (_vm.documentType),
      callback: function($$v) {
        _vm.documentType = $$v
      },
      expression: "documentType"
    }
  }), _c('template', {
    slot: "footer"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e374bec4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CreateDocumentTypeButtonModal.vue
// module id = 2737
// module chunks = 1